import { transformClientFormatToServer } from '../../lib/buttonModel';
import { defaultButton } from '../../reducers/reducerButtonFactory';
import _get from 'lodash/get';
import { voucherTypeToInputTypeMapping } from './utils/partnerUtils';
import {
  VOUCHER_TYPE_CUSTOM,
  INVALID_ADDRESS_ERROR,
} from './utils/voucherConstants';
import { normalizeNumber } from '../../utils/amountUtils';
import { fetcher } from '../../../utility/domUtils';

export const CREATE_DEFAULT_BUTTON = 'CREATE_DEFAULT_BUTTON';
export const CREATE_DEFAULT_BUTTON_SUCCESS = 'CREATE_DEFAULT_BUTTON_SUCCESS';
export const CREATE_DEFAULT_BUTTON_ERROR = 'CREATE_DEFAULT_BUTTON_ERROR';
export const EMAIL_CONFIRM_RESEND = 'EMAIL_CONFIRM_RESEND';
export const EMAIL_SEND_SUCCESS = 'EMAIL_SEND_SUCCESS';
export const EMAIL_SEND_SUCCESS_RESET = 'EMAIL_SENT_SUCCESSFULLY';
export const EMAIL_SEND_ERROR = 'EMAIL_SEND_ERROR';
export const CHECK_EMAIL_CONFIRMED = 'CHECK_EMAIL_CONFIRMED';
export const CHECK_EMAIL_CONFIRMED_RESPONSE = 'CHECK_EMAIL_CONFIRMED_RESPONSE';
export const CHECK_EMAIL_CONFIRMED_ERROR = 'CHECK_EMAIL_CONFIRMED_ERROR';
export const SET_VERIFY_EMAIL_MODAL_OPEN = 'SET_VERIFY_EMAIL_MODAL_OPEN';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const UPDATE_STEP = 'UPDATE_STEP';
export const SHOW_UNKNOWN_ERROR_OCCURED = 'SHOW_UNKNOWN_ERROR_OCCURED';
export const HIDE_UNKNOWN_ERROR_OCCURED = 'HIDE_UNKNOWN_ERROR_OCCURED';
export const SHOW_COUNTRY_NOT_SUPPORTED = 'SHOW_COUNTRY_NOT_SUPPORTED';
export const HIDE_COUNTRY_NOT_SUPPORTED = 'HIDE_COUNTRY_NOT_SUPPORTED';
export const TOGGLE_ADD_VOUCHER = 'TOGGLE_ADD_VOUCHER';
export const UPDATE_VOUCHER_DETAILS = 'UPDATE_VOUCHER_DETAILS';
export const UPDATE_VOUCHER_ZIPCODE = 'UPDATE_VOUCHER_ZIPCODE';
export const UPDATE_AGREEMENT = 'UPDATE_AGREEMENT';
export const UPDATE_BUSINESS_IMAGE_URLS = 'UPDATE_BUSINESS_IMAGE_URLS';
export const ADD_MERCHANT_FOOTER = 'ADD_MERCHANT_FOOTER';
export const UPDATE_SELECTED_VOUCHER_TYPE = 'UPDATE_SELECTED_VOUCHER_TYPE';
export const UPDATE_IS_MOBILE = 'UPDATE_IS_MOBILE';

/**
 * DOES_NOT create a default button as the API is WIP
 * Instead, creates a Button with the parameters passed
 */
export function createDefaultButton(
  bnCode,
  messageToDonors,
  presetAmounts,
  addVoucher = false,
  additionalVoucherInfo = {}
) {
  const buttonDataServerFormat = transformClientFormatToServer(defaultButton);
  const {
    voucherInfo,
    organizationName,
    businessImageUrls,
    country,
    isCountrySupportedForFbUpload,
  } = additionalVoucherInfo;
  const payload = {
    button: buttonDataServerFormat,
    default: 'true',
    bn: bnCode,
    purpose: messageToDonors,
    amount_options: presetAmounts,
    businessName: organizationName,
    imageData: {
      url: businessImageUrls && businessImageUrls.url,
      name: 'custom-donation-logo.png',
    },
  };

  if (addVoucher && voucherInfo) {
    const discountType = voucherTypeToInputTypeMapping.find(
      (mapping) => mapping.voucherType === voucherInfo.type
    ).voucherInputType;
    const discountValue =
      voucherInfo.type === VOUCHER_TYPE_CUSTOM
        ? 0
        : normalizeNumber(voucherInfo.value);

    payload.hasVoucher = addVoucher;
    payload.isCountrySupportedForFbUpload = isCountrySupportedForFbUpload;
    payload.voucherInput = {
      discountValue,
      discountType,
      offerTagline: voucherInfo.tagline,
      offerDetails: voucherInfo.details,
      address: {
        postal_code: voucherInfo.zipcode,
        country_code: country,
      },
    };
  }

  return (dispatch, getState) => {
    dispatch({
      type: CREATE_DEFAULT_BUTTON,
    });

    let resParams = {};
    return fetcher('/donate/api/buttons', {
      method: 'POST',
      body: JSON.stringify(payload),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          if (
            addVoucher &&
            responseJson &&
            responseJson.status === 400 &&
            _get(responseJson, 'responseJSON.button.message') &&
            _get(responseJson, 'responseJSON.button.message').includes(
              'Invalid address'
            )
          ) {
            dispatch({
              type: CREATE_DEFAULT_BUTTON_ERROR,
              error: INVALID_ADDRESS_ERROR,
            });
          } else {
            dispatch(showUnknownErrorOccured());
            dispatch({
              type: CREATE_DEFAULT_BUTTON_ERROR,
              error,
            });
          }
          return error;
        }
        const button = _get(responseJson, 'button');
        const offerProgramVariable = button.button_variables.filter(
          (variable) => {
            return variable.name === 'srt';
          }
        );
        const offerProgramCode = button && button.offerProgramCode;
        const offerProgramId =
          offerProgramVariable.length > 0 ? offerProgramVariable[0].value : '';
        dispatch({
          type: CREATE_DEFAULT_BUTTON_SUCCESS,
          payload: {
            id: responseJson && responseJson.button && responseJson.button.id,
            bnCode: bnCode,
            offerProgramId,
            offerProgramCode,
          },
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        if (
          addVoucher &&
          error &&
          error.status === 400 &&
          _get(error, 'responseJSON.button.message') &&
          _get(error, 'responseJSON.button.message').includes('Invalid address')
        ) {
          dispatch({
            type: CREATE_DEFAULT_BUTTON_ERROR,
            error: INVALID_ADDRESS_ERROR,
          });
        } else {
          dispatch(showUnknownErrorOccured());
          dispatch({
            type: CREATE_DEFAULT_BUTTON_ERROR,
            error,
          });
        }
        return error;
      });
  };
}

export const openVerifyEmailModal = () => (dispatch) => {
  dispatch({ type: SET_VERIFY_EMAIL_MODAL_OPEN });
};

export const checkIfEmailConfirmed = () => (dispatch) => {
  const url = '/donate/api/buttons/partner/confirmEmail';
  dispatch({ type: CHECK_EMAIL_CONFIRMED });

  let resParams = {};
  fetcher(url, {
    method: 'POST',
  })
    .then((response) => {
      resParams = {
        ...resParams,
        status: response.status,
        statusText: response.statusText,
        ok: response.ok,
      };
      return response.text();
    })
    .then((responseJson) => {
      const response = JSON.parse(responseJson);
      if (!resParams.ok) {
        const error = {
          responseJSON: response,
          ...resParams,
        };

        dispatch({ type: SHOW_UNKNOWN_ERROR_OCCURED });
        dispatch({ type: CHECK_EMAIL_CONFIRMED_ERROR, payload: error });
      } else if (response && typeof response.isEmailConfirmed !== 'undefined') {
        dispatch({
          type: CHECK_EMAIL_CONFIRMED_RESPONSE,
          payload: response.isEmailConfirmed,
        });
      } else {
        let stringifiedRes;
        try {
          JSON.stringify(response);
        } catch (err) {
          stringifiedRes = undefined;
        }
        dispatch({ type: SHOW_UNKNOWN_ERROR_OCCURED });
        dispatch({
          type: CHECK_EMAIL_CONFIRMED_ERROR,
          payload:
            'isEmailConfirmed lacking in response. Response:' + stringifiedRes,
        });
      }
    })
    .catch((error) => {
      dispatch({ type: SHOW_UNKNOWN_ERROR_OCCURED });
      dispatch({ type: CHECK_EMAIL_CONFIRMED_ERROR, payload: error });
    });
};

export const resendEmail = () => (dispatch) => {
  const url = '/donate/api/buttons/partner/resendEmail';
  dispatch({ type: EMAIL_CONFIRM_RESEND });

  let resParams = {};
  fetcher(url, {
    method: 'POST',
  })
    .then((response) => {
      resParams = {
        ...resParams,
        status: response.status,
        statusText: response.statusText,
        ok: response.ok,
      };
      return response.text();
    })
    .then((res) => {
      if (!resParams.ok) {
        const error = {
          responseJSON: res,
          ...resParams,
        };
        dispatch({ type: SHOW_UNKNOWN_ERROR_OCCURED });
        dispatch({ type: EMAIL_SEND_ERROR, payload: error });
      } else {
        dispatch({ type: EMAIL_SEND_SUCCESS });
        setTimeout(() => {
          dispatch({ type: EMAIL_SEND_SUCCESS_RESET });
        }, 3500);
      }
    })
    .catch((error) => {
      dispatch({ type: SHOW_UNKNOWN_ERROR_OCCURED });
      dispatch({ type: EMAIL_SEND_ERROR, payload: error });
    });
};

export function updateMessage(message) {
  return {
    type: UPDATE_MESSAGE,
    message,
  };
}

export function updateStep(step) {
  return {
    type: UPDATE_STEP,
    step,
  };
}

export function showUnknownErrorOccured() {
  return {
    type: SHOW_UNKNOWN_ERROR_OCCURED,
  };
}

export function hideUnknownErrorOccured() {
  return {
    type: HIDE_UNKNOWN_ERROR_OCCURED,
  };
}

export function showCountryNotSupported() {
  return {
    type: SHOW_COUNTRY_NOT_SUPPORTED,
  };
}

export function hideCountryNotSupported() {
  return {
    type: HIDE_COUNTRY_NOT_SUPPORTED,
  };
}

export function toggleAddVoucher() {
  return {
    type: TOGGLE_ADD_VOUCHER,
  };
}

export function updateVoucherDetails({
  voucherType,
  voucherValue,
  voucherDetails,
  discountTagline,
}) {
  return {
    type: UPDATE_VOUCHER_DETAILS,
    payload: {
      voucherType,
      voucherValue,
      voucherDetails,
      discountTagline,
    },
  };
}

export function updateSelectedVoucherType({ voucherType }) {
  return {
    type: UPDATE_SELECTED_VOUCHER_TYPE,
    voucherType,
  };
}

export function updateVoucherZipCode(zipcode) {
  return {
    type: UPDATE_VOUCHER_ZIPCODE,
    zipcode,
  };
}

export function updateVoucherAgreement(isOnAgreement) {
  return {
    type: UPDATE_AGREEMENT,
    isOnAgreement,
  };
}

export function updateBusinessImageUrls(url) {
  return {
    type: UPDATE_BUSINESS_IMAGE_URLS,
    url,
  };
}

export function updateIsMobile(isMobile) {
  return {
    type: UPDATE_IS_MOBILE,
    isMobile,
  };
}

export function addMerchantFooter(merchantFooter) {
  return {
    type: ADD_MERCHANT_FOOTER,
    merchantFooter,
  };
}
